module.exports = __webpack_public_path__ + "img/spurs.3ab0c0ca.png";